import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import PhysicalPersonUpdateComponent from './PhysicalPersonUpdate.component';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import User from 'src/entities/User';
import * as moment from 'moment';
import Spouse from 'src/value-objects/Spouse';
import { getPhysicalPerson, GetPhysicalPersonAction } from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import {
  changePhysicalPersonData,
  ChangePhysicalPersonDataAction
} from 'src/actions/physical-person/change-data/ChangePhysicalPersonData.actions';
import {
  updatePhysicalPerson,
  UpdatePhysicalPersonAction,
  UpdatePhysicalPersonSuccess
} from 'src/actions/physical-person/update/UpdatePhysicalPerson.actions';
import * as updatePhysicalPersonTypes from 'src/actions/physical-person/update/Types';
import Base64Encoder from 'src/services/encoders/Base64Encoder';
import * as getUserTypes from 'src/actions/user/get/Types';
import {
  indexSectorsOfInterest,
  IndexSectorsOfInterestAction
} from 'src/actions/sector-of-interest/index/IndexSectorsOfInterest.actions';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import {
  changeDefaultProfile,
  ChangeDefaultProfileAction
} from 'src/actions/default-profile/change/ChangeDefaultProfile.actions';
import * as changeDefaultProfileTypes from 'src/actions/default-profile/change/Types';
import Person from 'src/entities/Person';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';
import { getImage, GetImageAction, GetImageSuccess } from 'src/actions/image/get/GetImage.actions';

interface StateProps {
  user?: User;
  formData?: PhysicalPersonData;
  physicalPerson?: PhysicalPerson;
  loggedUserData: number | null;
  error: boolean;
  errorMessage: {};
  sectorsOfInterest: SectorOfInterest[];
  defaultProfile?: Person;
}

interface DispatchProps {
  changeDefaultProfile(userId: number, id: number, personType: string): Promise<ChangeDefaultProfileAction>;

  getUser(userId: number): Promise<GetUserAction>;

  getPhysicalPerson(physicalPersonId: number): Promise<GetPhysicalPersonAction>;

  changePhysicalPersonData(personData: PhysicalPersonData): ChangePhysicalPersonDataAction;

  updatePhysicalPerson(personData: PhysicalPersonData): Promise<UpdatePhysicalPersonAction>;

  indexSectorsOfInterest(): Promise<IndexSectorsOfInterestAction>;

  getImage(imageName: string): Promise<GetImageAction>;
}

interface Props extends StateProps, DispatchProps {
}

interface State {
  profilePicture?: File;
  idFront?: File;
  idBack?: File;
  success?: boolean;
  checkboxState: boolean;
  canChangeCheckbox: boolean;
}

class PhysicalPersonUpdateContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      checkboxState: false,
      canChangeCheckbox: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSpouse = this.handleChangeSpouse.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeDefaultProfile = this.handleChangeDefaultProfile.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.handlePublicProfileCheckbox = this.handlePublicProfileCheckbox.bind(this);
  }

  public componentWillMount(): void {
    this.props.indexSectorsOfInterest();
    const userId = this.props.loggedUserData!;
    this.props.getUser(userId).then((response) => {
      if (response.type === getUserTypes.GET_USER_SUCCESS) {
        this.props.getPhysicalPerson(this.props.user!.physicalPersonId).then(() => {
          this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.physicalPerson!));
          this.getImages(this.props.physicalPerson!);
          const ischecked = this.props.defaultProfile && this.props.physicalPerson &&
            this.props.defaultProfile.personType === 'physical'
            && this.props.defaultProfile.id === this.props.physicalPerson!.id;
          const canChange = !ischecked;
          this.setState({ checkboxState: ischecked!, canChangeCheckbox: canChange });
        });
      }
    });

    this.setState(
      { success: false }
    );
  }

  public render(): React.ReactNode {
    return (
      this.props.physicalPerson && this.props.formData ?
        (
          <PhysicalPersonUpdateComponent
            handleChange={this.handleChange}
            handleChangeSpouse={this.handleChangeSpouse}
            handleSubmit={this.handleSubmit}
            formData={this.props.formData}
            physicalPerson={this.props.physicalPerson}
            profilePicture={this.state.profilePicture}
            idFront={this.state.idFront}
            idBack={this.state.idBack}
            error={this.props.error}
            errorMessage={this.props.errorMessage}
            success={!!this.state.success}
            sectors={this.props.sectorsOfInterest}
            defaultProfile={this.props.defaultProfile}
            handleChangeDefaultProfile={this.handleChangeDefaultProfile}
            checkboxState={this.state.checkboxState}
            canChangeCheckbox={this.state.canChangeCheckbox}
            handleChangeCheckbox={this.handleChangeCheckbox}
            handlePublicProfileCheckbox={this.handlePublicProfileCheckbox}
          />
        ) :
        <LoadingContainer />
    );
  }

  private handleChangeDefaultProfile(): void {
    const userId = this.props.loggedUserData!;
    this.props.changeDefaultProfile(
      userId, this.props.physicalPerson!.id!, 'physical').then(
        (response: ChangeDefaultProfileAction) => {
          if (response.type === changeDefaultProfileTypes.CHANGE_DEFAULT_PROFILE_SUCCESS) {
            this.setState({ success: true });
          }
        });
  }

  private handleChange(key: string): (value: string | boolean | File | SectorOfInterest | moment.Moment) => void {
    switch (key) {
      case 'idExpirationDate':
        return (value: moment.Moment) => {
          this.props.formData!.idExpirationDate = value;
          this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.formData!));

        };
      case 'birthDate':
        return (value: moment.Moment) => {
          this.props.formData!.birthDate = value;
          this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.formData!));
        };
      case 'maritalEconomicStatus':
        return (value: string) => {
          if (value === 'Régimen de gananciales' && !this.props.formData!.spouse) {
            this.props.formData!.spouse = new Spouse({});
          } else if (value !== 'Régimen de gananciales' && this.props.formData!.spouse) {
            this.props.formData!.spouse = undefined;
          }
          this.props.formData![key] = value;
          this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.formData!));
        };
      case 'idFront':
        return (value: File) => {
          this.setState({ idFront: value });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.idFront = newImage;
            this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.formData!));
          });
        };
      case 'idBack':
        return (value: File) => {
          this.setState({ idBack: value });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.idBack = newImage;
            this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.formData!));
          });
        };
      case 'profilePicture':
        return (value: File) => {
          this.setState({ profilePicture: value });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.profilePicture = newImage;
            this.props.changePhysicalPersonData(new PhysicalPersonData(this.props.formData!));
          });
        };
      case 'sectorsOfInterest':
        return (value: SectorOfInterest) => {

          let newData = { ...this.props.formData! };
          let index = newData.sectorsOfInterest.findIndex(sector => sector.id === value.id);
          if (index !== -1) {
            newData.sectorsOfInterest.splice(index, 1);
          } else {
            newData.sectorsOfInterest.push(value);
          }
          this.props.changePhysicalPersonData(new PhysicalPersonData(newData));
        };
      default:
        return (value: string | boolean) => {
          let newData = { ...this.props.formData!, [key]: value };
          this.props.changePhysicalPersonData(new PhysicalPersonData(newData));
        };
    }
  }

  private handleChangeSpouse(key: string): (value: string | boolean | File | moment.Moment) => void {
    return (
      (value: string | boolean) => {
        if (this.props.formData!.spouse) {
          let newData = {
            ...this.props.formData!,
            spouse: {
              ...this.props.formData!.spouse,
              [key]: value
            }
          };
          this.props.changePhysicalPersonData(new PhysicalPersonData(newData));
        }
      }
    );
  }

  private handleSubmit(): void {
    this.props.updatePhysicalPerson(this.props.formData!).then((response: UpdatePhysicalPersonSuccess) => {
      if (response.type === updatePhysicalPersonTypes.UPDATE_PHYSICAL_PERSON_SUCCESS) {
        if (this.state.checkboxState === true) {
          this.handleChangeDefaultProfile();
        }
        this.setState(
          { success: true }
        );
      }
    });
  }

  private getImages(data: PhysicalPerson): void {
    if (data.profilePicture) {
      this.props.getImage(data.profilePicture).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({profilePicture: response.payload});
        }
      });
    }
    if (data.idFront) {
      this.props.getImage(data.idFront).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({idFront: response.payload});
        }
      });
    }
    if (data.idBack) {
      this.props.getImage(data.idBack).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({idBack: response.payload});
        }
      });
    }
  }

  private handleChangeCheckbox(): void {
    if (!this.state.canChangeCheckbox) {
      return;
    }
    this.setState({ checkboxState: !this.state.checkboxState });
  }

  private handlePublicProfileCheckbox(): void {
    let newData = { ...this.props.formData!, isPublicProfile: !this.props.formData!.isPublicProfile };
    this.props.changePhysicalPersonData(new PhysicalPersonData(newData));
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getUser: (userId: number): Promise<GetUserAction> => (
      dispatch(getUser(userId))
    ),
    getPhysicalPerson: (physicalPersonId: number): Promise<GetPhysicalPersonAction> => (
      dispatch(getPhysicalPerson(physicalPersonId))
    ),
    changePhysicalPersonData: (personData: PhysicalPersonData): ChangePhysicalPersonDataAction => (
      dispatch(changePhysicalPersonData(personData))
    ),
    updatePhysicalPerson: (personData: PhysicalPersonData): Promise<UpdatePhysicalPersonAction> => (
      dispatch(updatePhysicalPerson(personData))
    ),
    indexSectorsOfInterest: (): Promise<IndexSectorsOfInterestAction> => (
      dispatch(indexSectorsOfInterest())
    ),
    changeDefaultProfile: (userId: number, id: number, personType: string): Promise<ChangeDefaultProfileAction> => (
      dispatch(changeDefaultProfile(userId, id, personType))
    ),
    getImage: (imageName: string): Promise<GetImageAction> => (
      dispatch(getImage(imageName))
    ),
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user,
  formData: state.changePhysicalPersonData.physicalPerson,
  physicalPerson: state.getPhysicalPerson.physicalPerson,
  loggedUserData: state.authentication.loggedUserData,
  error: state.updatePhysicalPerson.error,
  errorMessage: state.updatePhysicalPerson.errorMessage,
  sectorsOfInterest: state.indexSectorOfInterest.sectorsOfInterest,
  defaultProfile: state.getUser.defaultProfile ? state.getUser.defaultProfile : undefined,
});

export default connect(mapStateToProps, mapDispatchToProps)(PhysicalPersonUpdateContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/PhysicalPersonUpdate.container.tsx